import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    getInitialEstimatedTradeCostConfigState,
    EstimatedTradeCostConfigState,
} from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostConfigState';
import { selectEstimatedTradeCostWidgetState } from 'widgets/estimatedTradeCost/widget/store/selectors';

export const buildEstimatedTradeCostWidgetConfigSlice = () =>
    buildConfigSlice<EstimatedTradeCostConfigState>(
        WidgetType.EST_TRADE_COST_WIDGET,
        selectEstimatedTradeCostWidgetState,
        getInitialEstimatedTradeCostConfigState()
    );

export const useEstimatedTradeCostWidgetConfigSlice = () =>
    useConfigSlice(buildEstimatedTradeCostWidgetConfigSlice());

export type EstimatedTradeCostConfigPayloadType =
    WidgetConfigSliceActionPayloadType<EstimatedTradeCostConfigState>;
